<template>
  <div class="grid">
    <Grid />
  </div>
</template>

<script>
// @ is an alias to /src
import Grid from "@/components/Grid.vue";

export default {
  name: "GridRoute",
  components: {
    Grid
  }
};
</script>
